import React from 'react';
import ReactDOM from 'react-dom';
import axios from 'axios';
import axiosInstance from '@cabinet-packages/api/axios';
import {AccessKey} from '@cabinet-packages/helpers';
import App from './App';
import * as serviceWorker from './serviceWorker';

const blockedEndpoints = ['/getPromotions'];

const requestInterceptor = (config) => {
    const token = AccessKey.get();
    if (token && !config.headers.Authorization) {
        config.headers.Authorization = 'Bearer ' + token;
    }

    if (config.url) {
        config.url = config.url
            .replace('/api/customers/getInfo/', '/api/agent/getDetails/')
            .replace('/api/customers/', '/api/agent/');
    }

    if (blockedEndpoints.some(endpoint => config.url?.includes(endpoint))) {
        const source = axios.CancelToken.source();
        config.cancelToken = source.token;
        source.cancel();
        return config;
    }

    return config;
};

axios.interceptors.request.use(requestInterceptor);
axiosInstance.interceptors.request.use(requestInterceptor);

ReactDOM.render(<App/>, document.getElementById('root'));

const element = document.getElementById('ipl-progress-indicator');
element.parentNode.removeChild(element);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
